<template>
  <div style="padding: 0; margin: 0;">
    <router-view></router-view>
  </div>
</template>

<style lang="scss">

// Main demo style scss
@import "assets/sass/bootstrap";
@import "assets/sass/bootstrap-extended";
@import "assets/sass/colors";
@import "assets/sass/components";
@import "assets/sass/themes/dark-layout";
@import "assets/sass/themes/semi-dark-layout";
@import "assets/sass/core/menu/menu-types/vertical-menu";
@import "assets/sass/style";

// 3rd party plugins css
@import "assets/vendors/css/vendors.min.css";

// Check documentation for RTL css
/*@import "assets/css/style.vue.rtl";*/

.btn-group-xs > .btn, .btn-xs {
  padding: .25rem .4rem;
  font-size: .875rem;
  line-height: .5;
  border-radius: .2rem;
}
.header-color{
  color: #464E5F !important;
}
.btn-outline-gray:not(:disabled):not(.disabled):active:focus, .btn-outline-gray:not(:disabled):not(.disabled).active:focus,
.show > .btn-outline-gray.dropdown-toggle:focus {
  box-shadow: 0 0 0 0.2rem rgba(150, 150, 150, 0.7);
}
</style>

<script>
import { OVERRIDE_LAYOUT_CONFIG } from "@/core/services/store/config.module";
import GeneralLoading from "@/assets/components/loader/GeneralLoading.vue";

export default {
  name: "MetronicVue",
  mounted() {
    /**
     * this is to override the layout config using saved data from localStorage
     * remove this to use config only from static json (@/core/config/layout.config.json)
     */
    this.$store.dispatch(OVERRIDE_LAYOUT_CONFIG);
  }
};
</script>
